import { getLogout, SuccessResponse } from '@back-office/http';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { ResponseMessage } from '../../constants';
import { Self } from '../common';

function* logoutRequest(
  self: Self,
  isForceLogout?: boolean
): Generator<Promise<FlowReturn<SuccessResponse>>> {
  self.isLoading = true;
  if (isForceLogout) {
    self.clearSession();
    self.isLoading = false;
    return Promise.resolve(ResponseMessage.OK);
  }
  try {
    const response = yield getLogout();
    const { status } = (response as SuccessResponse).data;
    if (status.code === 1000) {
      self.clearSession();
      return Promise.resolve(ResponseMessage.OK);
    }
    self.alert.title = status.messages[0];
    self.alert.open = true;
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    return Promise.reject(new Error(e.message));
  } finally {
    self.isLoading = false;
  }
}

export default logoutRequest;
